// ============================================================================
// sheep.flocks.index — migrated off the global read
// ============================================================================
// Sheep flocks hub at the empty suffix, the first localization to land.
//
// ONE FILE PER MIGRATED SURFACE, deliberately. This used to be one entry in a
// central MIGRATED map inside surfaceDataManifest.ts, which meant every
// concurrent localization edited the same object and collided. Discovery is now
// an eager glob over this directory, so two surfaces migrating at once touch
// two different files.
//
// The one-owner rule still holds and is still what makes a half-migrated state
// unrepresentable: this declaration REPLACES legacy.all for its surface rather
// than joining it. The physical reads it displaced must move to `retired` in
// render-read-sites.json in the same change, and
// tests/fixtures/migrated-surface-receipts/sheep.flocks.index.json is the independent
// historical record that this pair existed — so deleting both this file and the
// catalog resource together still fails.
// ============================================================================

import type {MigratedSurfaceDeclaration} from '../surfaceDataManifest';

const declaration: MigratedSurfaceDeclaration = Object.freeze({
  surface: 'sheep.flocks.index',
  obligations: Object.freeze([Object.freeze({id: 'sheep.flocks.core', owner: 'permanent'})]),
  residualLegacy: Object.freeze([]),
});

export default declaration;
